import { useCallback } from 'react';

import { VisitId } from '../types';

import { useEmergencyNotification } from './useEmergencyNotification';

type SetVisitForEmergencyNotification = (visitId: VisitId | null) => void;

export const useSetVisitForEmergencyNotification = (): SetVisitForEmergencyNotification => {
   const { setVisitForEmergencyNotification } = useEmergencyNotification();

   return useCallback<SetVisitForEmergencyNotification>(
      (visitId) => {
         setVisitForEmergencyNotification(visitId);
      },
      [setVisitForEmergencyNotification]
   );
};
